<template>
  <div>
    <b-modal id="modalFormClearCardUsers" lazy ref="modalFormClearCardUsers" :title="$t('Search parameters')" hide-footer size="lg" @shown="shown">
      <b-row class="mb-3">
        <b-col cols="4">
          <b-form-radio v-model="conditions" value="isBalance">{{ $t('Balance + Loan') }}</b-form-radio>
        </b-col>
        <b-col cols="4">
          <b-form-select v-model="curTypeBalance" :options="typeBalance"/>
        </b-col>
        <b-col cols="4">
          <b-form-input type="number" v-model="balance"/>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col cols="4">
          <b-form-radio v-model="conditions" value="isBlockType">{{ $t('Block type') }}</b-form-radio>
        </b-col>
        <b-col cols="4">
          <b-form-select v-model="curTypeBlock" :options="typeBlock"/>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col cols="4">
          <b-form-radio v-model="conditions" value="isCardExpired">{{ $t('Card is expired') }}</b-form-radio>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="findNow">{{ $t('Find now') }}</b-button>
        </b-col>
        <b-col cols="2">
          <b-button :disabled="cardUsers.length === 0" class="mt-3" variant="danger" style="float: right; width: 100px" @click="showDeleteCardUsers">{{ $t('Clear') }}</b-button>
        </b-col>
        <b-col cols="2">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideModalFormClearCardUsers">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal hide-footer :title="$t('Confirmation')" ref="modalDeleteUsers" id="modalDeleteUsers">
      <h5>{{ $t('All selected card users will be deleted. Are you sure?') }}</h5>
      <b-row>
        <b-col>
          <b-btn variant="danger" block @click="deleteCardUsers">Ok</b-btn>
        </b-col>
        <b-col>
          <b-btn variant="secondary" block @click="$bvModal.hide('modalDeleteUsers')">{{ $t('Cancel') }}</b-btn>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>

export default {
  data () {
    return {
      allAccounts: [],
      allCards: [],
      cardUsers: [],
      perPage: 20,
      conditions: 'isBalance',
      curTypeBalance: 1,
      balance: 0,
      typeBalance: [
        {value: 1, text: '<'},
        {value: 2, text: '>'},
        {value: 3, text: '='}
      ],
      curTypeBlock: 1,
      typeBlock: [
        {value: 256, text: this.$i18n.t('Admin blocking')},
        {value: 16, text: this.$i18n.t('System blocking')},
        {value: 1, text: this.$i18n.t('User blocking')}
      ],
      cardUsersFields: [
        { key: 'user_id', label: this.$i18n.t('ID'), sortable: true },
        { key: 'login', label: this.$i18n.t('Login'), sortable: true },
        { key: 'basic_account', label: this.$i18n.t('Basic account'), sortable: true },
        { key: 'full_name', label: this.$i18n.t('FullName'), sortable: true },
        { key: 'block', label: this.$i18n.t('Block') },
        { key: 'balance', label: this.$i18n.t('Balance'), sortable: true }
      ]
    }
  },
  methods: {
    async findNow () {
      this.cardUsers = JSON.parse(JSON.stringify(this.copyCardUsers))
      if (this.conditions === 'isBalance') {
        for (let el of this.cardUsers) {
          for (let elAcc of el.accounts) {
            for (let elAllAcc of this.allAccounts) {
              if (elAcc === elAllAcc.account_id) {
                el.allBalance += (elAllAcc.balance + elAllAcc.credit)
              }
            }
          }
        }
        if (this.curTypeBalance === 1) {
          this.cardUsers = this.cardUsers.filter((value) => {
            return value.allBalance < Number(this.balance)
          })
        }
        if (this.curTypeBalance === 2) {
          this.cardUsers = this.cardUsers.filter((value) => {
            return value.allBalance > Number(this.balance)
          })
        }
        if (this.curTypeBalance === 3) {
          this.cardUsers = this.cardUsers.filter((value) => {
            return value.allBalance === Number(this.balance)
          })
        }
      }
      if (this.conditions === 'isBlockType') {
        this.cardUsers = this.cardUsers.filter((value) => {
          return value.block_type_to_flags === this.curTypeBlock
        })
      }
      if (this.conditions === 'isCardExpired') {
        let copyCardUsers = []
        let nowTime = this.$root.setDataWithSelectedTZ().format('YYYY-MM-DD')
        nowTime = Number(Date.parse(nowTime)) / 1000
        for (let elUsers of this.cardUsers) {
          for (let elCard of this.allCards) {
            if (elUsers.pass === elCard.secret) {
              if (elCard.expire < nowTime) {
                copyCardUsers.push(elUsers)
              }
            }
          }
        }
        this.cardUsers = copyCardUsers
      }
    },
    showDeleteCardUsers () {
      this.$refs.modalDeleteUsers.show()
    },
    async deleteCardUsers () {
      for (let el of this.cardUsers) {
        for (let elAcc of el.accounts) {
          await this.$store.dispatch('Users/GET_USER_SERVICES_LINKS_ACC', elAcc).then(response => {
            let seviceLinks = this.$store.getters['Users/USER_SERVICES_LINKS_ACC']
            if (seviceLinks.length > 0) {
              for (let elServices of seviceLinks) {
                if (elServices.service_type === 3) {
                  this.$store.dispatch('Tariffing/DELETE_RADIUS_SESSION', elServices.service_link_id)
                }
                this.$store.dispatch('Users/DELETE_USER_SERVICES_LINKS', elServices.service_link_id)
              }
            }
          })
          let payload = {
            user_id: el.user_id,
            account_id: elAcc
          }
          await this.$store.dispatch('Users/GET_USER_TARIFF_LINKS', payload).then(response => {
            let tariffLinks = this.$store.getters['Users/USER_TARIFF_LINKS']
            if (tariffLinks.length > 0) {
              for (let elTariffs of tariffLinks) {
                let delTariffLink = {
                  user_id: el.user_id,
                  account_id: elAcc,
                  tplink_id: elTariffs.id
                }
                this.$store.dispatch('Users/DELETE_USER_TARIFF_LINKS', delTariffLink)
              }
            }
          })
        }
        let response = await this.$store.dispatch('Users/DELETE_USERS', el.user_id)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.load()
            this.$root.$emit('makeToasts')
          }
        })
      }
      this.cardUsers = []
      this.$refs.modalDeleteUsers.hide()
    },
    shown () {
      if (this.allCards.length === 0) {
        for (let el of this.$store.getters['Users/CARD_POOLS']) {
          if (el.cards) {
            this.$store.dispatch('Users/GET_CARD_POOL', el.pool_id).then(response => {
              for (let elCard of this.$store.getters['Users/CARD_POOL'].info) {
                this.allCards.push(elCard)
              }
            })
          }
        }
      }
      if (this.allAccounts.length === 0) {
        for (let el of this.copyCardUsers) {
          for (let elAcc of el.accounts) {
            this.$store.dispatch('Users/GET_ACCOUNT_ACC', elAcc).then(response => {
              let newEl = {
                balance: this.$store.getters['Users/ACCOUNT_ACC'].balance,
                credit: this.$store.getters['Users/ACCOUNT_ACC'].credit,
                user_id: this.$store.getters['Users/ACCOUNT_ACC'].user_id,
                account_id: this.$store.getters['Users/ACCOUNT_ACC'].account_id
              }
              this.allAccounts.push(newEl)
            })
          }
        }
      }
      this.cardUsers = []
      this.conditions = 'isBalance'
      this.curTypeBalance = 1
      this.balance = 0
      this.curTypeBlock = 1
    },
    hideModalFormClearCardUsers () {
      this.$refs.modalFormClearCardUsers.hide()
    }
  },
  watch: {
    copyCardUsers: function (val) {
      this.cardUsers = val
    }
  },
  computed: {
    copyCardUsers () {
      let copy = []
      for (let el of JSON.parse(JSON.stringify(this.$store.getters['Users/USERS_LIST'].users))) {
        for (let elUsers of JSON.parse(JSON.stringify(this.$store.getters['Users/USERS'].users))) {
          if (elUsers.login === el.login) {
            el.pass = elUsers.password
            el.accounts = elUsers.accounts
          }
        }
        el.allBalance = 0
        switch (el.block_type_to_flags) {
          case 0:
            el.block = this.$i18n.t('No')
            break
          case 16:
            el.block = this.$i18n.t('System blocking')
            break
          case 256:
            el.block = this.$i18n.t('Admin blocking')
            break
          case 1:
            el.block = this.$i18n.t('User blocking')
            break
        }
        el.balance = Number.parseFloat(el.balance).toFixed(2)
        copy.push(el)
      }
      return copy
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/formClearCardUsers.vue